module.exports = __webpack_public_path__ + "static/img/left_login_bg.47c5bf31.png";